export omniLocalizationSagas from './pages/Omni/omniSales/localizationSagas';
export myplanSagas from './pages/MyPlan/myplan/myplanSagas';
export showOffersFilter from './pages/MyPlan/showOffers/showOffersFilterSagas';
export addOnSagas from './pages/MyPlan/addOn/addOnSagas';
export upsellSagas from './pages/MyPlan/upsell/upsellSagas';
export cancelSagas from './pages/MyPlan/cancel/cancelSagas';
export myplanReviewSagas from './pages/MyPlan/review/reviewSagas';
export myplanConfirmationSagas from './pages/MyPlan/confirmation/confirmationSagas';
export errorSagas from './pages/error/errorSagas';
export offersSagas from './data/offers/offersSagas';
export equipmentSagas from './data/equipment/equipmentSagas';
export customerSagas from './data/customer/customerSagas';
export contextSagas from './data/context/contextSagas';
export planSagas from './data/plan/planSagas';
export moversLocalizationSagas from './pages/Movers/localization/localizationSagas';
export moversUnserviceableSagas from './pages/Movers/unserviceable/unserviceableSagas';
export moversCancelSagas from './pages/Movers/cancel/cancelSagas';
export moversSpecialistSagas from './pages/Movers/specialist/specialistSagas';
export moversInstallSagas from './pages/Movers/install/installSagas';
export moversReviewSagas from './pages/Movers/review/reviewSagas';
export moversConfirmationSagas from './pages/Movers/confirmation/confirmationSagas';
export checkoutSagas from './pages/QuickCheckout/checkout/checkoutSagas';
export reviewSagas from './pages/QuickCheckout/review/reviewSagas';
export confirmationSagas from './pages/QuickCheckout/confirmation/confirmationSagas';
export redirectSagas from './pages/QuickCheckout/redirect/redirectSagas';
export accountSagas from './pages/Account/account/accountSagas';
export accountMultipleAddressSagas from './pages/Account/multipleAddress/multipleAddressSagas';
export omniLandingSagas from './pages/MyPlan/omni/omniLandingSagas';
export dataLayerSagas from './dataLayer/dataLayerSagas';
export targetSagas from './target/targetSagas';



/** WEBPACK FOOTER **
 ** ./client/redux/modules/sagas.js
 **/